import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _ttmlFunc from "../functions/profiles/ttmlGeneral.js";
import _ittFunc from "../functions/profiles/iTunesTimedText.js";
import { XMLParser as _XMLParser } from "fast-xml-parser";
import _orderByTime from "../functions/eventGroups/orderByTime.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _frameRatesDict from "../dict/frameRates.js";
import _eol from "eol";
const eol = _eol;
const frameRatesDict = _frameRatesDict;
const removeInvalidEvents = _removeInvalidEvents;
const orderByTime = _orderByTime;
const XMLParser = _XMLParser;
const ittFunc = _ittFunc;
const ttmlFunc = _ttmlFunc;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const getFormatOptions = _getFormatOptions;
export default {
  decode: function (input, options) {
    let events = [],
      timeBase = "media",
      useClockTime = false;
    const xmlToJson = new XMLParser({
      stopNodes: ["*.p"],
      numberParseOptions: {
        skipLike: /[0-9]+/
      },
      ignoreAttributes: false
    });
    let fileJson = xmlToJson.parse(input);
    //if the fileJson is missing the tt element we need to add it in
    if (!fileJson.tt) {
      fileJson = {
        tt: fileJson
      };
    }
    timeBase = ttmlFunc.getTimeBaseValue(input) || "media";
    useClockTime = timeBase === "media" || timeBase === "clock" ? true : false;

    //console.log(fileJson);
    let frameRate = fileJson.tt['@_ttp:frameRate'] || options.frameRate;
    let frameRateMultiplier = fileJson.tt['@_ttp:frameRateMultiplier'];
    let dropFrame = fileJson.tt['@_ttp:dropMode'];
    if (frameRateMultiplier === "999 1000" || frameRateMultiplier === "1000 1001") {
      if (frameRate == 24) {
        frameRate = 23.976;
      } else if (frameRate == 30) {
        frameRate = 29.97;
      }
    }
    frameRate = parseFloat(frameRate);
    if (dropFrame === undefined) {
      dropFrame = frameRatesDict.dropFrameMap[frameRate];
    } else if (dropFrame === "nonDrop") {
      dropFrame = false;
    }

    //Build a map of the styles defined in the head so span/body style ids can be resolved
    let styleMap = ittFunc.buildStyleMap(fileJson.tt.head);
    //Read the body level defaults (default style + region) that apply unless overridden
    let defaultStyleId = fileJson.tt.body ? fileJson.tt.body['@_style'] : undefined;
    let defaultRegion = fileJson.tt.body ? fileJson.tt.body['@_region'] : undefined;
    if (Array.isArray(fileJson.tt.body.div)) {
      fileJson.tt.body.div.forEach(captionBlock => {
        //console.log(captionBlock);
        events = [...events, ...ittFunc.decodeCaptionBlock(captionBlock, frameRate, dropFrame, useClockTime, styleMap, defaultStyleId, defaultRegion)];
      });
    } else {
      //console.log(fileJson.tt.body.div);
      let captionBlock = fileJson.tt.body.div;
      events = [...events, ...ittFunc.decodeCaptionBlock(captionBlock, frameRate, dropFrame, useClockTime, styleMap, defaultStyleId, defaultRegion)];
    }
    return events;
  },
  encode: function (eventGroup, options) {
    let tcSource = "smpte";
    let frameRate = ittFunc.frameRateMap[options.frameRate];
    let frameRateMultiplier = ittFunc.frameRateMultiplierMap[options.frameRate];
    let encodingOptions = getFormatOptions(options.formatOptions);
    let languageCode = "en-US";
    if (encodingOptions["Language Code"]) {
      languageCode = encodingOptions["Language Code"] || "en-US";
    }
    let rtlFlag = languageCode.startsWith("ar") || languageCode.startsWith("he") ? true : false;
    if (encodingOptions["Timecode Source"]) {
      tcSource = encodingOptions["Timecode Source"].toLowerCase();
    }
    let useClockTime = tcSource === "media" || tcSource === "clock" ? true : false;
    let output = eol.after(`<?xml version="1.0" encoding="UTF-8"?>`);
    output += eol.after(`<tt xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://www.w3.org/ns/ttml" xmlns:tt="http://www.w3.org/ns/ttml" xmlns:tts="http://www.w3.org/ns/ttml#styling" xmlns:ttp="http://www.w3.org/ns/ttml#parameter" xml:lang="${languageCode}" ttp:timeBase="${tcSource}" ttp:frameRate="${frameRate}" ttp:frameRateMultiplier="${frameRateMultiplier}" ttp:dropMode="${options.dropFrame ? "dropNTSC" : 'nonDrop'}">`);
    output += eol.after(`\t<head>
        <styling>
            <style xml:id="normal" tts:fontFamily="sansSerif" tts:fontWeight="normal" tts:fontStyle="normal" tts:color="white" tts:fontSize="100%"/>
            <style xml:id="bold" tts:fontFamily="sansSerif" tts:fontWeight="bold" tts:fontStyle="normal" tts:color="white" tts:fontSize="100%"/>
            <style xml:id="italic" tts:fontFamily="sansSerif" tts:fontWeight="normal" tts:fontStyle="italic" tts:color="white" tts:fontSize="100%"/>
            <style xml:id="underline" tts:fontFamily="sansSerif" tts:fontWeight="normal" tts:fontStyle="normal" tts:textDecoration="underline" tts:color="white" tts:fontSize="100%"/>
        </styling>
        <layout>
            <region xml:id="top" tts:displayAlign="before" tts:origin="0% 0%" tts:extent="100% 15%" tts:textAlign="center"/>
            <region xml:id="bottom" tts:displayAlign="after" tts:origin="0% 85%" tts:extent="100% 15%" tts:textAlign="center"/>
        </layout>
    </head>`);
    output += eol.after(`\t<body style="normal" region="bottom">`);
    eventGroup = orderByTime(eventGroup);
    output += eol.after(`\t\t<div begin="${options.incode}">`);
    eventGroup.events.forEach(event => {
      // console.log("---------------")
      //console.log(event.start,event.end, options.frameRate, options.dropFrame);
      let startTc = useClockTime ? event.startSmpteBaseClock : event.startSmpteBase;
      let endTc = useClockTime ? event.endSmpteBaseClock : event.endSmpteBase;
      //console.log(startTc, endTc);
      // console.log(event.text);
      // console.log(ittFunc.convertToItt(event.text));
      let region = event.yPos === 'start' || !isNaN(event.yPos) && event.yPos / options.window.height < 0.5 ? "top" : "bottom";

      // console.log("----------")
      // console.log("RAW:" +event.text);
      let plainTextCustom = convertToPlainTextCustom(event.text);

      // console.log("BEFORE: "+plainTextCustom);
      let text = ttmlFunc.multiLine.convertToTtml(plainTextCustom);

      //Replace <span tts:fontStyle='italic'> with <span style="italic"> and the same for bold and underline
      text = text.replace(/<span tts:fontStyle='italic'>/g, "<span style='italic'>");
      text = text.replace(/<span tts:fontWeight='bold'>/g, "<span style='bold'>");
      text = text.replace(/<span tts:textDecoration='underline'>/g, "<span style='underline'>");
      output += `\t\t\t<p begin="${startTc}" end="${endTc}" region="${region}"${rtlFlag ? ' tts:direction="rtl"' : ''}>${text}</p>\n`;
    });
    output += `\t\t</div>
    </body>
</tt>`;
    return eol.auto(output);
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      /* All */
      return eol.lf(input.trim()).replace(/'(\n){3,}'/gim, "\n\n");
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};